/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/GoldBadge.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const GoldBadge: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 66 28" ref={ref} {...props}>
    <rect width="66" height="28" fill="url(#GoldBadge-gold-badge-bg)" rx="14" />
    <path
      fill="#262626"
      d="M23 6.67H9a.5.5 0 0 0-.5.5v2.5a2.5 2.5 0 0 0 2.5 2.5 5 5 0 0 0 4.5 4.97v1.71c-1.81.1-3.5.78-3.5 1.98a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5c0-1.2-1.69-1.88-3.5-1.98v-1.7a5 5 0 0 0 4.5-4.98 2.5 2.5 0 0 0 2.5-2.5v-2.5a.5.5 0 0 0-.5-.5m-13.5 3v-2H11v3.5a1.5 1.5 0 0 1-1.5-1.5m13 0a1.5 1.5 0 0 1-1.5 1.5v-3.5h1.5zm-6.34-.23a.2.2 0 0 0-.16-.1.2.2 0 0 0-.16.1l-.52 1.1-1.16.18a.2.2 0 0 0-.15.13.2.2 0 0 0 .04.2l.85.85-.2 1.21a.2.2 0 0 0 .07.19q.1.06.2.01l1.03-.57 1.04.57q.1.05.2-.01a.2.2 0 0 0 .06-.19l-.2-1.21.84-.86a.2.2 0 0 0 .05-.2.2.2 0 0 0-.15-.12l-1.16-.18zm19.1 3.22q-.32-.58-.86-.87-.55-.3-1.28-.3-.8 0-1.43.36t-.97 1.04-.35 1.56q0 .9.35 1.59.36.68 1 1.04t1.48.36q1.05 0 1.7-.55.67-.55.88-1.54h-3.12v-1.4h4.91v1.6a4.45 4.45 0 0 1-4.43 3.54q-1.32 0-2.38-.6a4.4 4.4 0 0 1-2.26-4.04q0-1.34.6-2.4t1.66-1.64 2.36-.6a4.7 4.7 0 0 1 2.67.75q1.13.75 1.56 2.1zm6.6 6.46q-1.05 0-1.88-.46t-1.31-1.31a4 4 0 0 1-.47-1.95q0-1.11.48-1.95.5-.84 1.34-1.3.86-.47 1.89-.47 1.04 0 1.88.47t1.33 1.3q.5.84.5 1.95t-.52 1.95q-.49.84-1.35 1.31-.85.45-1.9.46m0-1.59q.48 0 .92-.23.45-.25.7-.73.26-.48.26-1.17 0-1.03-.55-1.57-.53-.56-1.3-.56-.8 0-1.32.56-.52.54-.52 1.57 0 1.02.5 1.58.52.55 1.3.55m6.65-8.15V19h-1.82V9.38zm1.07 6q0-1.1.43-1.94.44-.85 1.2-1.3a3.2 3.2 0 0 1 3-.15q.65.3 1.02.8v-3.4h1.85V19h-1.85v-1.07q-.33.54-.95.86-.6.33-1.41.33a3 3 0 0 1-1.67-.47q-.75-.47-1.2-1.31a4 4 0 0 1-.42-1.97m5.67.02q-.01-.66-.26-1.13-.27-.48-.7-.73-.45-.26-.96-.26a1.8 1.8 0 0 0-1.63.98q-.27.46-.26 1.11 0 .66.26 1.15a2 2 0 0 0 .7.74q.44.26.93.26.51 0 .95-.25.45-.25.7-.73.27-.48.27-1.14"
    />
    <defs>
      <radialGradient
        id="GoldBadge-gold-badge-bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(33 0 0 96.9529 33 13.263)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#f2de7a" />
        <stop offset="1" stopColor="#ae7c2b" />
      </radialGradient>
    </defs>
  </svg>
);
GoldBadge.displayName = "GoldBadge";
